module.exports = {"445224100":"惠城镇","445224102":"华湖镇","445224103":"仙庵镇","445224104":"靖海镇","445224105":"周田镇","445224106":"前詹镇","445224107":"神泉镇","445224108":"东陇镇","445224109":"岐石镇","445224110":"隆江镇","445224111":"溪西镇","445224112":"鳌江镇","445224113":"东港镇","445224114":"葵潭镇","445224115":"侨园镇","445224401":"东埔农场","445224403":"葵潭农场","445224404":"青坑林场","445224450":"揭阳（惠来）沿海经济开发试验区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/445224.json
// module id = 2188
// module chunks = 0